var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1171275949(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#FA5A7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5003 34.3333C43.4793 34.3333 45.0837 32.729 45.0837 30.75C45.0837 28.771 43.4793 27.1667 41.5003 27.1667C39.5213 27.1667 37.917 28.771 37.917 30.75C37.917 32.729 39.5213 34.3333 41.5003 34.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7503 55.8333C32.7293 55.8333 34.3337 54.229 34.3337 52.25C34.3337 50.271 32.7293 48.6667 30.7503 48.6667C28.7713 48.6667 27.167 50.271 27.167 52.25C27.167 54.229 28.7713 55.8333 30.7503 55.8333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7503 45.0833C32.7293 45.0833 34.3337 43.479 34.3337 41.5C34.3337 39.521 32.7293 37.9167 30.7503 37.9167C28.7713 37.9167 27.167 39.521 27.167 41.5C27.167 43.479 28.7713 45.0833 30.7503 45.0833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7503 34.3333C32.7293 34.3333 34.3337 32.729 34.3337 30.75C34.3337 28.771 32.7293 27.1667 30.7503 27.1667C28.7713 27.1667 27.167 28.771 27.167 30.75C27.167 32.729 28.7713 34.3333 30.7503 34.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2503 34.3333C54.2293 34.3333 55.8337 32.729 55.8337 30.75C55.8337 28.771 54.2293 27.1667 52.2503 27.1667C50.2713 27.1667 48.667 28.771 48.667 30.75C48.667 32.729 50.2713 34.3333 52.2503 34.3333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7087 52.3754V54.9375C39.7087 55.4392 40.1028 55.8333 40.6045 55.8333H43.1128C43.3457 55.8333 43.5787 55.7438 43.7399 55.5646L54.1853 45.1192L50.387 41.3208L39.9774 51.7304C39.7982 51.9096 39.7087 52.1425 39.7087 52.3754ZM41.5541 45.0833L45.0837 41.5538V41.5C45.0837 39.5292 43.4712 37.9167 41.5003 37.9167C39.5295 37.9167 37.917 39.5292 37.917 41.5C37.917 43.4708 39.5295 45.0833 41.5003 45.0833H41.5541ZM57.3566 40.7117L54.8303 38.1854C54.472 37.8271 53.9166 37.8271 53.5582 38.1854L51.6591 40.0846L55.4574 43.8829L57.3566 41.9838C57.7149 41.6254 57.7149 41.07 57.3566 40.7117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275949);
export default __webpack_public_path__ + "static/media/Group 1171275949.8bcae3ef1ef3d4ffad893a00ac4b96fb.svg";
export { ForwardRef as ReactComponent };